import { Overlay } from '@react-aria/overlays'
import { Children, type ReactElement, type ReactNode, type Ref } from 'react'

import { PopoverProvider } from './PopoverContext'
import { usePopover, type TUsePopoverProps } from './usePopover'

export type TPopoverProps = TUsePopoverProps & {
  /**
   * Ref to the DOM node.
   */
  ref?: Ref<'div'>
  /**
   * The content of the popover. It is usually the `PopoverTrigger`,
   * and `PopoverContent`
   */
  children: ReactNode[] | ReactNode | ReactElement
}

export const Popover = ({ ref, ...props }: TPopoverProps) => {
  const { children, ...otherProps } = props
  const context = usePopover({ ...otherProps, ref })

  const [trigger, content] = Children.toArray(children)

  const overlay = <Overlay portalContainer={context.portalContainer}>{content}</Overlay>

  return (
    <PopoverProvider value={context}>
      {trigger}
      {!!context.isOpen && overlay}
    </PopoverProvider>
  )
}
